import { useCallback, useEffect, useState } from "react";

function secondsUntil(expireAt: string | null): number {
  if (!expireAt) return 0;
  return Math.max(0, Math.floor((new Date(expireAt).getTime() - Date.now()) / 1000));
}

export function useExpireCountdown(expireAtInput: string | null) {
  const [expireAt, setExpireAt] = useState(expireAtInput);

  useEffect(() => {
    setExpireAt(expireAtInput);
  }, [expireAtInput]);

  const [timeLeft, setTimeLeft] = useState(() => secondsUntil(expireAtInput));

  useEffect(() => {
    if (!expireAt) {
      setTimeLeft(0);
      return;
    }

    const tick = () => setTimeLeft(secondsUntil(expireAt));
    tick();
    const id = window.setInterval(tick, 1000);
    return () => window.clearInterval(id);
  }, [expireAt]);

  const isExpired = expireAt != null && timeLeft <= 0;

  const resetExpireAt = useCallback((next: string) => {
    setExpireAt(next);
    setTimeLeft(secondsUntil(next));
  }, []);

  return { timeLeft, isExpired, resetExpireAt };
}
